import React from 'react';
import {Framework7App} from 'framework7-react';
import MainViews from './MainViews.jsx';

let framework7;
export const getFramework7 = () => framework7;

/// Sets up Framework7 and creates the main views.
///
/// Change themeType to "material" to use the Material theme.
export const App = () => (
	<Framework7App themeType="ios" swipeBackPage={false} routes={[]} onFramework7Init={(f7) => {framework7 = f7}}>
		<MainViews />
	</Framework7App>
);



// WEBPACK FOOTER //
// ./src/components/App.jsx